import * as loadModule from './wasm/web-evaluator';
import { float32ToArrayBuffer, getTimeUnit } from './util';
// 只支持采样深度为16bit
const srcSampleBit = 16;
let Module;
/**
 * 载入 we 模块
 */
export async function loadWebEvaluator() {
    Module = loadModule.default ? await loadModule.default() : await loadModule();
}
export class WebEvaluator {
    constructor(option) {
        if (option && option.srcSampleRate) {
            option['timeUnit'] = getTimeUnit(option.srcSampleRate);
        }
        // 设置默认值
        this.option = Object.assign({
            timeUnit: getTimeUnit(8000),
            srcSampleRate: 8000,
            srcSampleBit
        }, option);
        if (!Module) {
            throw new Error("Have to call load first.");
        }
        this.we = new Module.WebEvaluator(this.option);
    }
    get score() {
        return this._score;
    }
    get bufferScore() {
        return this._bufferScore;
    }
    /**
     * 载入 erc 信息
     * @param url :erc 文件地址或者erc文件内容
     * @return
     */
    async loadErc(url) {
        let buffer;
        if (typeof url === 'string') {
            try {
                const response = await fetch(url);
                buffer = await response.arrayBuffer();
            }
            catch (e) {
                console.error(e);
                throw new Error(`无法加载erc: ${url}`);
            }
        }
        else {
            buffer = url;
        }
        return new Promise(resolve => {
            resolve(this.we.loadErc(buffer));
        });
    }
    getEur() {
        return this.we.getEur();
    }
    /**
     * 获取音频段得分
     *  需要持续调用
     * @param buffer - 音频段数据 ArrayBuffer int16 littleEndian
     * @param duration - 音频段持续时长 (s)
     * @return {WMG.Score} - 当前得分
     */
    getSongScore(buffer, duration) {
        if (buffer instanceof Float32Array) {
            buffer = float32ToArrayBuffer(buffer);
        }
        // 检测数据采样率，采样深度，时间与数据长度是否匹配
        if (Math.ceil(this.option.srcSampleRate * srcSampleBit / 8 * duration) !== buffer.byteLength) {
            throw new Error('Length of buffer does not match duration. Make sure the sampling bit is 16 bits');
        }
        this._score = this.we.getSongScore(buffer, duration);
        this._bufferScore = this.we.getBufferScore();
        return this._score;
    }
    /**
     * 删除wmg对象 垃圾回收
     */
    delete() {
        var _a;
        (_a = this.we) === null || _a === void 0 ? void 0 : _a.delete();
        this.we = null;
    }
}
